// src/components/common/Loading.js
import React from 'react';
import './Loading.scss';

const Loading = ({ text = '로딩 중...' }) => {
  return (
    <div className="loading">
      <div className="loading__spinner"></div>
      <p className="loading__text">{text}</p>
    </div>
  );
};

export default Loading;
